// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c0-b";
export var colorBlue = "_c0-8";
export var colorDot = "_c0-0";
export var colorDotLarge = "_c0-2";
export var colorDotSmall = "_c0-1";
export var colorGreen = "_c0-7";
export var colorGrey = "_c0-3";
export var colorOrange = "_c0-5";
export var colorPink = "_c0-a";
export var colorPurple = "_c0-9";
export var colorRed = "_c0-4";
export var colorYellow = "_c0-6";